"use strict";

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _this = this;

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var Procedure_1 = require("./Procedure");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");

var utils_1 = require("../utils");

var entities_1 = require("../entities");
/**
 * @hidden
 */


exports.createTogglePauseStoResolver = function (factories, symbol, stoType, stoAddress) {
  return function () {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var securityTokenId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              securityTokenId = entities_1.SecurityToken.generateId({
                symbol: symbol
              });
              _context.t0 = stoType;
              _context.next = _context.t0 === types_1.StoType.Simple ? 4 : _context.t0 === types_1.StoType.Tiered ? 5 : 6;
              break;

            case 4:
              return _context.abrupt("return", factories.simpleStoFactory.refresh(entities_1.SimpleSto.generateId({
                securityTokenId: securityTokenId,
                stoType: stoType,
                address: stoAddress
              })));

            case 5:
              return _context.abrupt("return", factories.tieredStoFactory.refresh(entities_1.TieredSto.generateId({
                securityTokenId: securityTokenId,
                stoType: stoType,
                address: stoAddress
              })));

            case 6:
              return _context.abrupt("return", undefined);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
};
/**
 * Procedure to pause or unpause an STO
 */


var TogglePauseSto =
/*#__PURE__*/
function (_Procedure_1$Procedur) {
  _inherits(TogglePauseSto, _Procedure_1$Procedur);

  function TogglePauseSto() {
    var _this2;

    _classCallCheck(this, TogglePauseSto);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(TogglePauseSto).apply(this, arguments));
    _this2.type = types_1.ProcedureType.TogglePauseSto;
    return _this2;
  }
  /**
   * Pause or unpause the STO
   *
   * Note this procedure will fail if:
   * - The specified STO address is invalid
   * - The specified STO type is invalid
   * - The STO has not been launched, or the module has been archived
   */


  _createClass(TogglePauseSto, [{
    key: "prepareTransactions",
    value: function prepareTransactions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this$args, stoAddress, stoType, symbol, pause, _this$context, contractWrappers, factories, stoModule;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$args = this.args, stoAddress = _this$args.stoAddress, stoType = _this$args.stoType, symbol = _this$args.symbol, pause = _this$args.pause;
                _this$context = this.context, contractWrappers = _this$context.contractWrappers, factories = _this$context.factories;
                /*
                 * Validation
                 */

                if (utils_1.isValidAddress(stoAddress)) {
                  _context2.next = 4;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.InvalidAddress,
                  message: "Invalid STO address ".concat(stoAddress)
                });

              case 4:
                _context2.t0 = stoType;
                _context2.next = _context2.t0 === types_1.StoType.Simple ? 7 : _context2.t0 === types_1.StoType.Tiered ? 11 : 15;
                break;

              case 7:
                _context2.next = 9;
                return contractWrappers.moduleFactory.getModuleInstance({
                  name: contract_wrappers_1.ModuleName.CappedSTO,
                  address: stoAddress
                });

              case 9:
                stoModule = _context2.sent;
                return _context2.abrupt("break", 16);

              case 11:
                _context2.next = 13;
                return contractWrappers.moduleFactory.getModuleInstance({
                  name: contract_wrappers_1.ModuleName.UsdTieredSTO,
                  address: stoAddress
                });

              case 13:
                stoModule = _context2.sent;
                return _context2.abrupt("break", 16);

              case 15:
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "Invalid STO type ".concat(stoType)
                });

              case 16:
                if (stoModule) {
                  _context2.next = 18;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "STO ".concat(stoAddress, " is either archived or hasn't been launched")
                });

              case 18:
                _context2.next = 20;
                return this.addTransaction(pause ? stoModule.pause : stoModule.unpause, {
                  tag: pause ? types_1.PolyTransactionTag.PauseSto : types_1.PolyTransactionTag.UnpauseSto,
                  resolvers: [exports.createTogglePauseStoResolver(factories, symbol, stoType, stoAddress)]
                })({});

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return TogglePauseSto;
}(Procedure_1.Procedure);

exports.TogglePauseSto = TogglePauseSto;